import { BsCaretRightFill } from 'react-icons/bs';
import styled from 'styled-components';
import { useFormContext } from 'react-hook-form';

import { colors } from 'constants/colors';

import { MicrostoreElementState } from 'data/__generated__';

import { TotemLabel } from 'components/TotemLabel';
import { ColumnSelect } from 'components/Select/ColumnSelect';

const SELECTABLE_COLUMN_STATES = [MicrostoreElementState.Regular];

export const ColumnsSelector = ({ isDisabled }: { isDisabled?: boolean }) => {
    const { watch, setValue } = useFormContext();
    const originColumnId = watch('originColumnId');
    const destinationColumnId = watch('destinationColumnId');

    return (
        <Container>
            <ColumnInput>
                <ColumnSelect
                    label="Colonne de départ"
                    value={originColumnId}
                    onChange={(id) => setValue('originColumnId', id, { shouldDirty: true })}
                    disabled={isDisabled}
                    dataTest="origin-column"
                    prioritizeWarehouses
                    states={SELECTABLE_COLUMN_STATES}
                />
            </ColumnInput>
            <TransferIcon>
                <TotemLabel>&nbsp;</TotemLabel>
                <BsCaretRightFill size={25} color={colors.green} />
            </TransferIcon>
            <ColumnInput>
                <ColumnSelect
                    label="Colonne d'arrivée"
                    value={destinationColumnId}
                    onChange={(id) => setValue('destinationColumnId', id, { shouldDirty: true })}
                    disabled={isDisabled}
                    dataTest="destination-column"
                    prioritizeWarehouses
                    states={SELECTABLE_COLUMN_STATES}
                />
            </ColumnInput>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;

const TransferIcon = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 5px;

    & > :not(:first-child) {
        margin-top: 5px;
    }
`;

const ColumnInput = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    & > :not(:first-child) {
        margin-top: 5px;
    }
`;
